module.exports = __webpack_public_path__ + "static/img/empty-search.a2ae9abd.png";